import React, { useState, useEffect } from 'react'
import { getUserPortals } from '../../services/portal';
import { Loader } from '@components';
import { constant } from '@app/utils/constant';

const AdminDashboard = () => {
    const [isLoading, setLoading] = useState(true);
    const [listData, setListData] = useState([]);
    useEffect(() => {
        getPostalList();
    }, [])

    const getPostalList = (filter = "") => {
        setLoading(true);
        getUserPortals(filter).then(function (res) {
            const resp = res.data;
            if (resp.Acknowledge == 1 && resp.records) {
                let data: any = [];
                resp.records.map((val: any, i: any) => {
                    let link = '';
                    if (constant.ENV == 'local') {
                        link = val.dev_url;
                    } else if (constant.ENV == 'staging') {
                        link = val.dev_url;
                    } else {
                        link = val.prod_url;
                    }
                    data[i] = {
                        id: val.id,
                        name: val.name,
                        image: val.image,
                        link: link
                    };
                });
                setListData(data);
                setLoading(false);
            }
        }).catch(err => {
            setLoading(false);
            return false;
        });
    };

    return (
        <section className="content mt-4">
            <div className="container-fluid">
                <h5 className='mb-3 row'>
                    <div className="col-md-6">
                        Slomins Admin Portals
                    </div>
                </h5>
                <div className='row'>
                    {
                        listData.length > 0 && listData.map((row: any, podidx: number) => (
                            <div className="col-12 col-sm-12 col-md-4 col-lg-2 mb-4" key={podidx}>
                                <div className="card-deck">
                                    <div className={`card portal-card`}>
                                        <img className="card-img-top p-2" src={`/img/portals/${row.image}`} alt={row.name} />
                                        <div className="card-footer card-f-per">
                                            <a target='_blank' href={row.link} className='sitelink'>
                                                <h5 className="card-title card-t-per w-100">
                                                    {row.name}
                                                    <i className="fas fa-chevron-right float-right"></i>
                                                </h5>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    {!isLoading && listData.length == 0 && <h5 className='ml-2'>You don't have any permission, please contact to administrator department</h5>}
                </div>
                {isLoading &&
                    <div className='admimnloader'>
                        <Loader isLoading={isLoading} />
                    </div>
                }
            </div>
        </section>
    );
};

export default AdminDashboard;
